import React from 'react'
import styles from './index.module.scss'


export default function Sidebar() {
    return (
        <>
            <div className={`${styles.sidebar} ${styles.sidebarCollapsed}`}>

            </div>
        </>
    )
}
